export enum DeviceHistoryRecordType {
  INCIDENT = 'INCIDENT',
  DEVICE_EVENT = 'DEVICE_EVENT',
  RMA = 'RMA',
}

export enum DeviceHistoryRecordCategory {
  BATTERY_REPLACEMENT = 'BATTERY_REPLACEMENT',
  SIM_CARD_CHANGE = 'SIM_CARD_CHANGE',
  ENCLOSURE_DEGRADATION = 'ENCLOSURE_DEGRADATION',
  FLOOD_DAMAGE = 'FLOOD_DAMAGE',
  ANTENNA_REPLACEMENT = 'ANTENNA_REPLACEMENT',
  POWER_SUPPLY_PROBLEM = 'POWER_SUPPLY_PROBLEM',
  PHYSICAL_DAMAGE = 'PHYSICAL_DAMAGE',
  STOLEN = 'STOLEN',
  WRONG_CONFIGURATION = 'WRONG_CONFIGURATION',
  OTHER = 'OTHER',
}

export interface DeviceRmaRecordDto {
  id: number | null;
  date: string | null; // LocalDate (yyyy-MM-dd)
  type: DeviceHistoryRecordType;
  category: DeviceHistoryRecordCategory;
  comments: string | null;
}
